import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class SharedDataService {
    private dataSubject = new BehaviorSubject<any>(null); // Objeto inicial vacío
    currentData$ = this.dataSubject.asObservable();

    updateData(data: any) {
        this.dataSubject.next(data);
    }
}
